<footer   style="background-color: #BF0404 ; "class="footer">
    <div class="footer-content justify-content-between">
      <p style="color: white;" class="m-b-0">
  <a href="https://www.ama-business.com" style="color: white; text-decoration: none;">
    Copyright © AMA-Business
  </a>
</p>
    </div>
</footer>